import React from 'react';
import { Mail } from 'lucide-react';
import styles from './LoginForm.module.css';

interface MagicLinkSentProps {
  email: string;
}

export function MagicLinkSent({ email }: MagicLinkSentProps) {
  return (
    <div className={styles.container}>
      <div className={styles.heroIcon}>
        <Mail size={48} strokeWidth={1.5} aria-hidden />
      </div>
      <div className={`${styles.header} ${styles.headerCentered}`}>
        <h1 className={styles.title}>Check your email</h1>
        <p className={styles.subtitle}>
          We've sent a magic link to <strong>{email}</strong>.<br />
          Click the link to sign in.
        </p>
      </div>
      <p className={styles.note}>
        Didn't receive the email? Check your spam folder or try again.
      </p>
    </div>
  );
}
